import ProfilMisiInternasionalContent from "../../components/layouts/misi-internasional/ProfilMisiInternasionalContent";

import React from "react";

const ProfilMisiInt: React.FC = () => {
  return (
    <div>
      <ProfilMisiInternasionalContent />
    </div>
  );
};

export default ProfilMisiInt;
